import React, { useState } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  StepContent,
  makeStyles,
  createStyles,
  Box,
} from '@material-ui/core';
import {
  ContactInfoStepContent,
  ContactData,
} from './contact-info-step-content';
import { SubscriptionStep } from './subscription-step';
import { ConnectWithTrainer } from './connect-with-trainer';
import { MembershipTrainerData } from '../../templates/trainer-membership';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import { OtpValidation } from './otp-validation';

const HIDE_PAYMENT = true

const useStyles = makeStyles(({ palette, breakpoints }) =>
  createStyles({
    root: {
      padding: 0,
      backgroundColor: palette.background.default,
      [breakpoints.up('sm')]: {
        backgroundColor: palette.background.paper,
      },
    },
    step: {
      minHeight: '45vh',
    },
  })
);

interface Props {
  trainerData: MembershipTrainerData;
}

export const MembershipForm: React.FC<Props> = ({ trainerData }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [reenterPhone, setReenterPhone] = useState(false)
  const classes = useStyles();

  const handleContactNext = (data: ContactData) => {
    trackCustomEvent({
      category: "Membership",
      action: "Click",
      label: `Provided Contact Info`,
      value: trainerData.price
    })
    setActiveStep(1);
  };

  const handleOtpNext = (phoneValidated: boolean) => {
    trackCustomEvent({
      category: "Membership",
      action: "Input",
      label: `Validate OTP`
    })
    if(phoneValidated){
      setActiveStep(2);
    }
  }

  const handleSubscriptionBack = () => {
    trackCustomEvent({
      category: "Membership",
      action: "Click",
      label: `Returned Back to customer info`,
      value: trainerData.price
    })
    setActiveStep(0);
  };

  const handleSubscriptionApprove = () => {
    trackCustomEvent({
      category: "Membership",
      action: "Subscribed",
      label: `Started Membership with trainer`,
      value: trainerData.price
    })
    setActiveStep(2);
  };

  const handleReenterPhone = () => {
    setReenterPhone(true)
    setActiveStep(0)
  }

  return (
    <Stepper
      className={classes.root}
      activeStep={activeStep}
      orientation="vertical"
    >
      <Step>
        <StepLabel>Contact Info</StepLabel>
        <StepContent>
          <Box className={classes.step}>
            <ContactInfoStepContent reenterPhone={reenterPhone} enablePreOrder={HIDE_PAYMENT} trainerData={trainerData} onNext={handleContactNext} />
          </Box>
        </StepContent>
      </Step>
      <Step>
        <StepLabel>Verify Account</StepLabel>
        <StepContent>
          <Box className={classes.step}>
            <OtpValidation onReenterPhone={handleReenterPhone} onNext={handleOtpNext} />
          </Box>
        </StepContent>
      </Step>
      {!HIDE_PAYMENT && (<Step>
        <StepLabel>Membership</StepLabel>
        <StepContent>
          <Box className={classes.step}>
            <SubscriptionStep
              onBack={handleSubscriptionBack}
              trainerData={trainerData}
              onApprove={handleSubscriptionApprove}
            />
          </Box>
        </StepContent>
      </Step>)}
      <Step>
        <StepLabel>Connect with Trainer</StepLabel>
        <StepContent>
          <Box className={classes.step}>
            <ConnectWithTrainer trainerData={trainerData} />
          </Box>
        </StepContent>
      </Step>
    </Stepper>
  );
};
